/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const MultiValue = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.MultiValue {...otherProps} className={className}>
      {children}
    </components.MultiValue>
  );
};

MultiValue.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

MultiValue.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default MultiValue;
